// Injects a Cloudinary delivery transformation into an existing upload URL,
// e.g. https://res.cloudinary.com/<cloud>/image/upload/v.../id.jpg
//   -> https://res.cloudinary.com/<cloud>/image/upload/<transformation>/v.../id.jpg
// Falls back to the original URL if it doesn't look like a Cloudinary upload URL.
function withTransformation(url: string, transformation: string): string {
  const marker = '/upload/';
  const markerIndex = url.indexOf(marker);
  if (markerIndex === -1) return url;

  const insertAt = markerIndex + marker.length;
  return `${url.slice(0, insertAt)}${transformation}/${url.slice(insertAt)}`;
}

export function cloudinaryResized(url: string, width: number): string {
  return withTransformation(url, `w_${width},q_auto,f_auto,c_limit`);
}

// For the backup/archive download — compressed but not aggressively resized,
// and forced to JPEG (not WebP/AVIF) so extracted files open everywhere
// without a modern-format viewer.
export function cloudinaryArchiveVersion(url: string): string {
  return withTransformation(url, 'q_auto:good,f_jpg,w_2000,c_limit');
}
